"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const classnames_1 = require("classnames");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const Card_1 = require("../card/Card");
const assets_1 = require("../config/assets");
const Icon_1 = require("../icon/Icon");
const ShoppingCartTable_1 = require("./ShoppingCartTable");
class ShoppingCart extends React.Component {
    constructor() {
        super(...arguments);
        this.getCart = () => {
            const { items, total, classes, t, onAddItem, onRemoveItem, onRemoveAll, proceedCheckout } = this.props;
            if (!items || !items.length) {
                return ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ container: true }, { children: (0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ item: true, xs: 12, id: 'empty-cart' }, { children: [(0, jsx_runtime_1.jsx)("img", { alt: 'Your Cart is empty. Start Adding Items', className: classes.emptyCartBackground, "aria-hidden": "true", src: assets_1.assets.internalAssets.emptyCart }), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { fontSize: '80px', height: 0 } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: 'shopping_cart', iconType: 'material', className: classes.emptyCartIcon, fontSize: "inherit" }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.emptyCartText }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h5", color: "textPrimary", align: 'justify' }, { children: t('store.shoppingCart.noItems') })), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", color: "textPrimary", align: 'justify', style: { paddingTop: '10px' } }, { children: t('store.shoppingCart.addItems') }))] }))] })) })));
            }
            return ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(ShoppingCartTable_1.default, { onAddItem: onAddItem, onRemoveItem: onRemoveItem, onRemoveAll: onRemoveAll, items: items, total: total, proceedCheckout: proceedCheckout }) })));
        };
    }
    render() {
        const { t, classes } = this.props;
        return ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ className: (0, classnames_1.default)(classes.card, 'po-widget-card') }, { children: (0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, spacing: 4, style: { padding: '16px' } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h5", color: "secondary", align: 'justify', component: 'h2' }, { children: t('store.shoppingCart.title') })) })), this.getCart()] })) })));
    }
}
const styles = (theme) => (0, core_1.createStyles)({
    emptyCartBackground: {
        marginLeft: theme.spacing(3),
        marginTop: theme.spacing(),
        opacity: 0.1,
        [theme.breakpoints.down('xs')]: {
            width: '90%'
        }
    },
    emptyCartIcon: {
        color: theme.palette.common.white,
        opacity: 0.38,
        position: 'relative',
        top: '-110px',
        left: theme.spacing(3)
    },
    emptyCartText: {
        position: 'relative',
        top: '-100px',
        left: '110px',
        height: 0,
        paddingBottom: theme.spacing(3)
    },
    card: {
        backgroundColor: theme.palette.primary.dark.getWithAlpha(0.7)
    }
});
exports.default = (0, core_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(ShoppingCart));
//# sourceMappingURL=ShoppingCart.js.map